"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var waitForElement_1 = require("../../../../../ww_project/Resources/Private/app/helpers/waitForElement");
/**
 * Scrolls to the respective Compusoft element when a specific anchor link is given to the url.
 *
 * Desc:
 * - #lastminute: "Lückenfinder"
 * - #coupon: "Gutschein"
 */
var CompusoftWaitForElementScroll = /** @class */ (function () {
    function CompusoftWaitForElementScroll() {
        // Tuple for page data (selector, delay, altSelector)
        this.elementsToCheck = [
            ['lastminute', 800, '#csobLastMinuteContainer'],
            ['coupon', 800, '[name="HeaderContainer"]'],
        ];
        this.compusoftElement = document.querySelector('#csob-main-layout-wrapper');
        if (!this.compusoftElement)
            return;
        this.initScroll(this.getCurrentAnchorElement());
    }
    // Scroll to element after it has been loaded
    CompusoftWaitForElementScroll.prototype.initScroll = function (data) {
        if (!data[0])
            return;
        var selector = data[0];
        var delay = data[1];
        var interval;
        // Start observer when target element is loaded in
        (0, waitForElement_1.waitForElement)(selector).then(function (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            interval = window.setInterval(function () {
                element.scrollIntoView({ behavior: 'smooth' });
            }, 500);
            setTimeout(function () {
                observerInt.observe(element);
            }, delay);
        });
        // Check when to stop scrolling if element is reached
        var configInt = { threshold: .1 };
        var observerInt = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    window.clearInterval(interval);
                    observerInt.disconnect();
                }
            });
        }, configInt);
    };
    // Get string in array that currently corresponds to the ID in the url
    CompusoftWaitForElementScroll.prototype.getCurrentAnchorElement = function () {
        var currentID = window.location.href.split('#')[1];
        var elementName = '';
        var elementDelay = 0;
        for (var _i = 0, _a = this.elementsToCheck; _i < _a.length; _i++) {
            var _b = _a[_i], name_1 = _b[0], delay = _b[1], altName = _b[2];
            if (currentID == name_1) {
                elementName = altName ? altName : "#".concat(name_1);
                elementDelay = delay;
            }
        }
        return [elementName, elementDelay];
    };
    return CompusoftWaitForElementScroll;
}());
exports.default = CompusoftWaitForElementScroll;
